import React, { Component } from 'react';
import { CollapsibleCard } from '../../shared/CollapsibleCard';
import { CustomKendoGrid } from '../../shared/CustomKendoGrid';
import { GridColumn, GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { PayrollDataService } from '../../services/PayrollDataService';
import { ViewReportButton } from '../../shared/ViewReportButton';

export class W2History extends Component {
    constructor(props) {
        super(props);
        this.payrollDataService = new PayrollDataService();
        this.getw2Data = this.getw2Data.bind(this);
        this.handlePrint = this.handlePrint.bind(this);

        this.gridRef = null;
        this.setGridRef = element => {
            this.gridRef = element;
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps) return null;
        if (!this.props) return null;
        if (!this.gridRef) return null;
        if (prevProps.district !== this.props.district) {
            this.gridRef.handleDataCallback();
        }
        return null;
    }

    getw2Data() {
        return this.payrollDataService.getW2Info(this.props.district);
    };

    handlePrint(obj) {
        if (obj.isCorrection) {
            return this.payrollDataService.getW2C(obj.id)
                .then(data => data.json());
        } else {
            return this.payrollDataService.getW2(obj.id)
                .then(data => data.json());
        }
    }

    render() {
        return (
            <CollapsibleCard title='W-2 Forms'>
                <CustomKendoGrid
                    ref={this.setGridRef}
                    refreshData={this.getw2Data}>
                    <GridColumn cell={(props) => (
                        <td>
                            <ViewReportButton defaultFilename='w2.pdf' getData={() => this.handlePrint(props.dataItem)}></ViewReportButton>
                        </td>
                    )} />
                    <GridColumn title="Tax Year" field="year" filter="numeric" columnMenu={GridColumnMenuFilter}/>
                    <GridColumn title="Description" field="IsCorrection" />
                </CustomKendoGrid>
            </CollapsibleCard>);
    }
}